export const environment = {
  production: false,
  apiBaseUrl: 'https://blaze.manjalitechnologies.in/api/v1',
};
